import "../scss/style.scss";
import $ from 'jquery';
import 'slick-carousel';
import "./lib/ofi.min.js";
import "./home.js";


jQuery(function ($) {

	// js-fixedBox
	$(window).scroll(function () {
		if($(window).scrollTop() > 10) {
			$('.js-fixedBox').addClass('fixedBox-on');
			$('.js-switch-txt').css({'display':'none'});
		} else {
			$('.js-fixedBox').removeClass('fixedBox-on');
			$('.js-switch-txt').css({'display':'block'});
		}
	});

	// smooth scroll
	$(function(){
		media();
		$(window).on(function(){ media(); });
		function media() {
		var width = $(window).width();
		if(width > 769) {
			$('a[href^="#"]').click(function(){
				var speed = 1000;
				var href= $(this).attr("href");
				var target = $(href == "#" || href == "" ? 'html' : href);
				var position = target.offset().top;
				$("html, body").animate({scrollTop:position}, speed, "swing");
				return false;
			});
			} else if(width <= 768) {
				$('a[href^="#"]').click(function(){
					var headerHight = 48;
					var speed = 1000;
					var href= $(this).attr("href");
					var target = $(href == "#" || href == "" ? 'html' : href);
					var position = target.offset().top - headerHight;
					$("html, body").animate({scrollTop:position}, speed, "swing");
					return false;
				});
			}
		}
	});

	// SP nav
	$(document).ready(function () {
		$('.js-navBt').on('click', function () {
			if ($('.js-navContent, .js-navBg').hasClass('nav-on')) {
				$(".js-navContent, .js-navBg").removeClass('nav-on');
				$(this).removeClass('nav-on');
			} else {
				$(".js-navContent, .js-navBg").addClass('nav-on');
				$(this).addClass('nav-on');
			}
		});
		$('.js-navBt.nav-on, .js-nav-link, .js-navBg').on('click', function () {
			$(".js-navBt.nav-on, .js-navContent, .js-navBg").removeClass('nav-on');
		});
	});

	// scroll animation
	$(window).on('load scroll', function () {
		$('.js-secAnime').each(function () {
			var elemPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > elemPos - windowHeight + 100) {
				$(this).addClass('anime-on');
			}
			// else {
			// 	$(this).removeClass('anime-on');
			// }
		});
	});

	if($('.mw_wp_form_confirm, .mw_wp_form_complete').length) {
    $('.required, .infoCheck').css('display', 'none');
	}

});
